import React from 'react'
import { useDispatch } from 'react-redux'
import { connectRefinementList } from 'react-instantsearch-dom'
import { setFiltersChange } from '../../store/actions'

const RefinementList = ({
  items,
  refine
}) => {
  const dispatch = useDispatch()

  // hack for profile count on newsroom profile list
  setTimeout(() => {
    dispatch(setFiltersChange(Date.now()))
  }, 50)

  const algoliaMatchs = {"Actualité" : "news", "Document": "doc", "Évènement": "event", "Page" : "page", "Solution": "solution", "Offre": "offer"}

  return (
    <ul>
      {items.map(item => {
        let count = (item.count < 10) ? `0${item.count}` : item.count

        if (item.label === 'Evénement') {
          item.label = 'Évènement'
        }

        return (
          <li key={item.label} data-value={algoliaMatchs[item.label]} className={`ais-RefinementList-item ${item.isRefined ? 'ais-RefinementList-item--selected' : ''}`}>
            <button
              className="ais-RefinementList-label"
              onClick={event => {
                refine(item.value)

                setTimeout(() => {
                  dispatch(setFiltersChange(Date.now()))
                }, 50)
              }}
            >
              { item.label }
              <span className="ais-RefinementList-count center"><span>{count}</span></span>
            </button>
          </li>
        )
      })}
    </ul>
  )
}

const CustomFilters = connectRefinementList(RefinementList)

export default CustomFilters